import React from 'react'

import PropTypes from 'prop-types'

import { Container, Error } from './styles'

import { AiFillCloseCircle } from 'react-icons/ai'

const InputBase = React.forwardRef(
  (
    {
      name,
      label,
      icon: Icon,
      error,
      clearable,
      rightIcon: RightIcon,
      containerStyle = {},
      onFocus,
      onBlur,
      hidden,
      containerClassName,
      ...props
    },
    ref
  ) => {
    const inputRef = React.useRef(null)

    React.useImperativeHandle(ref, () => inputRef?.current)

    const [isFocused, setIsFocused] = React.useState(false)
    const [isFilled, setIsFilled] = React.useState(false)

    const handleInputBlur = React.useCallback(
      (...args) => {
        setIsFocused(false)

        setIsFilled(Boolean(inputRef.current?.value))

        if (onBlur) onBlur(...args)
      },
      [onBlur, inputRef]
    )

    const handleInputFocus = React.useCallback(
      (...args) => {
        setIsFocused(true)

        if (onFocus) onFocus(...args)
      },
      [onFocus]
    )

    return (
      <Container
        hidden={hidden}
        style={containerStyle}
        hasError={Boolean(error)}
        isFocused={isFocused}
        isFilled={isFilled}
        className={containerClassName}
        data-testid="input-base-container">
        {label && <label htmlFor={`input-${name}`}>{label}</label>}

        {Icon && <Icon size={20} />}

        <input
          name={name}
          {...props}
          id={`input-${name}`}
          ref={inputRef}
          onBlur={handleInputBlur}
          onFocus={handleInputFocus}
          style={{ paddingRight: '8px' }}
        />

        {RightIcon && <RightIcon size={20} style={styles.rightIcon} />}

        {clearable && (
          <AiFillCloseCircle
            size={14}
            color={'rgba(0,0,0, .35)'}
            onClick={() => {
              inputRef.current.value = ''
            }}
            style={styles.clear}
          />
        )}

        {error && (
          <Error>
            {error}
          </Error>
        )}
      </Container>
    )
  }
)

InputBase.displayName = 'Input'

InputBase.defaultProps = {
  autoComplete: 'off'
}

InputBase.propTypes = {
  name: PropTypes.string.isRequired,
  error: PropTypes.string,
  clearable: PropTypes.bool,
  icon: PropTypes.elementType,
  rightIcon: PropTypes.elementType,
  containerStyle: PropTypes.object,
  hidden: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.any,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  containerClassName: PropTypes.any
}

const styles = {
  rightIcon: {
    margin: '0 .25rem 0 1rem'
  },
  clear: {
    margin: '0',
    cursor: 'pointer',
    position: 'absolute',
    right: '4px'
  }
}

export default InputBase
